const ObjectCacheReducer = (state = { caches: {} }, action) => {
    switch (action.type) {
        case 'SAVE_TO_CACHE':
            const { schemaKey, objectKey, value } = action.payload;
            return {
                ...state,
                caches: {
                    ...state.caches,
                    [schemaKey]: {
                        ...state.caches[schemaKey],
                        [objectKey]: JSON.parse(JSON.stringify(value)) // Deep clone
                    }
                }
            };
        
        case 'DELETE_FROM_CACHE':
            const { schemaKey: deleteSchemaKey, objectKey: deleteObjectKey } = action.payload;
            if (state.caches[deleteSchemaKey]) {
                const { [deleteObjectKey]: deleted, ...rest } = state.caches[deleteSchemaKey];
                return {
                    ...state,
                    caches: {
                        ...state.caches,
                        [deleteSchemaKey]: rest
                    }
                };
            }
            return state;
        
        case 'CLEAR_SCHEMA_CACHE':
            const { schemaKey: clearSchemaKey } = action.payload;
            const newCaches = { ...state.caches };
            delete newCaches[clearSchemaKey];
            return {
                ...state,
                caches: newCaches
            };
        
        case 'HYDRATE_OBJECT_CACHE':
            return {
                ...state,
                caches: action.payload.caches || {}
            };
        
        default:
            return state;
    }
};

export default ObjectCacheReducer;
